import React from 'react';
import AppLoading from '../components/AppLoading';
import { PagesCommonProps } from '../helpers/pagesUtil';
import SummaryCardContainer from '../components/SummaryCardsContainer';
import { mergeChartConfigWithApiData } from '../helpers/chartConfigHelper';
import { dashboardGraphsOptions, GOOGLE_CHARTS_TYPES } from '../consts/graphs';
import ChartContainer, { ChartContainerProps } from '../components/Charts/ChartContainer';
import useFetchDashboard5Data from '../hooks/fetchDataComponents/useFetchDashboard5Data';

const { PIECHART, TABLE, LINECHART } = GOOGLE_CHARTS_TYPES;

const Page5DashboardGraphs: React.FC<PagesCommonProps> = ({ filters, graphs = [] }) => {
  const { isLoadingMap, data, onScroll, onSortChange, exportActions, endpointsMap } = useFetchDashboard5Data({ filters, graphs });

  if (isLoadingMap?.fetchSummaryCardsData) return <AppLoading />;

  const baseChartsConfig: ChartContainerProps[] = [
    {
      onScroll,
      chartType: LINECHART,
      boxWidth: "55%",
      title: 'Average Course Rating by Month',
      chartId: "fetchAverageCourseRatingByMonthData",
      options: dashboardGraphsOptions.BarChartOptions.GetByColumnLength(
        data?.fetchAverageCourseRatingByMonthData?.data?.[0],
      ),
    },
    {
      onScroll,
      chartType: PIECHART,
      boxWidth: "35%",
      title: 'Rating Breakdown',
      chartId: "fetchRatingBreakdownData",
      options: dashboardGraphsOptions.PieChartOptions,
    },
    {
      onScroll,
      onSortChange,
      boxWidth: "40%",
      chartType: TABLE,
      title: 'Overall Course Rating',
      chartId: "fetchOverallCourseRatingData",
      options: dashboardGraphsOptions.TableChartOptions,
    },
    {
      onScroll,
      onSortChange,
      boxWidth: "25%",
      chartType: TABLE,
      title: 'Highest Rated Courses',
      chartId: "fetchHighestRatedCoursesData",
      options: dashboardGraphsOptions.TableChartOptions,
    },
    {
      onScroll,
      onSortChange,
      boxWidth: "25%",
      chartType: TABLE,
      title: 'Lowest Rated Courses',
      chartId: "fetchLowestRatedCoursesData",
      options: dashboardGraphsOptions.TableChartOptions,
    },
    {
      onScroll,
      onSortChange,
      chartType: TABLE,
      chartId: "fetchIndividualCourseRatingWithCommentsData",
      title: 'Individual Course Rating w/Comments',
      options: dashboardGraphsOptions.TableChartOptions,
    },
  ];

  // Merge base configuration with API data and filter/sort
  const ChartsListData: ChartContainerProps[] = mergeChartConfigWithApiData(baseChartsConfig, graphs);

  return (
    <>
      <SummaryCardContainer summaryCardsData={data?.fetchSummaryCardsData?.data as any} />
      
      <div className="charts-container">
        {ChartsListData.map((props, idx) => {
          const chartId = props.chartId;
          if (!chartId) return null;
          return (
            <ChartContainer 
              {...props} 
              key={idx} 
              index={idx}
              queryParams={filters}
              exportActions={exportActions}
              data={data?.[chartId as keyof typeof data]?.data}
              total={data?.[chartId as keyof typeof data]?.total}
              endpoint={endpointsMap?.[chartId as keyof typeof endpointsMap]}
              isLoading={isLoadingMap?.[chartId as keyof typeof isLoadingMap]}
            />
          );
        })}
      </div>
    </>
  );
};

export default Page5DashboardGraphs;
